import axios from 'axios';
import {API} from "@/services/url";

export default {
	getAllCompanies : function (success, error) {
		axios.get(API.company.companyList)
			.then(r => success(r.data.companyList))
			.catch(e => error(e.response.data.message));
	},
	getCompanyDetails : function (companyId, success, error) {
		axios.get(API.company.companyList + companyId)
			.then(r => success(r.data))
			.catch(e => error(e.response.data.message));
	},
	createNewCompany : function (data, success, error) {
		axios.post(API.company.create, data)
			.then(r => success(r.data.companyList))
			.catch(e => error(e.response.data.message));
	},
	updateCompany : function (companyId, data, success, error){
		axios.post(API.company.update + companyId, data)
			.then(r => success(r.data.companyList))
			.catch(e => error(e.response.data.message));
	}
}

